import "./Form.css"

const Form = ({input, handleInput, handleSubmit}) => {

    
  return (
    <div>
        <form onSubmit={handleSubmit}>
            <input
            input={input} 
            type="text" 
            placeholder="create a new todo..." 
            id="input" value={input} 
            onChange={handleInput} />
        </form>
    </div>
  )
}

export default Form